import posthog from 'posthog-js'

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;

const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;

// Initialize once, only in the browser
if (typeof window !== 'undefined' && !window.__posthog_inited) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    defaults: '2025-05-24',
    capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
    debug: process.env.NODE_ENV === "development",
  });
  window.__posthog_inited = true;
}

export { posthog }
